import { AutoComplete } from "antd";
import "./styles.scss";
import { t } from "i18next";
import { useEffect } from "react";
export default function DBAutoComplete(props) {
    const searchHandle = (string) => {
        const option = props.options.find(
            (option) => option.label.toUpperCase() === string.toUpperCase()
        );

        if (option) {
            props.onLock?.(string, option);
        }
    };

    return (
        <div className="db-auto-complete">
            <AutoComplete
                {...props}
                defaultActiveFirstOption
                className="db-auto-complete"
                placeholder={t("search.and.select")}
                size="large"
                filterOption={(inputValue, option) =>
                    option?.value
                        .toUpperCase()
                        .indexOf(inputValue.toUpperCase()) !== -1
                }
                onBlur={(e) => {
                    searchHandle(e.target.value.trim());
                }}
                dropdownStyle={{
                    maxHeight: 400,
                    overflow: "auto",
                    zIndex: 999999,
                }}
                onSearch={searchHandle}
            />
        </div>
    );
}
